import type { AccessPolicy, AccessPolicyResource } from '@medplum/fhirtypes'
import { Group } from '@seen/core/groups'
import { useContext } from 'react'
import { ConfigContext } from '#src/contexts/config/ConfigContext.tsx'
import { useMedplum } from '#src/hooks/useMedplum.ts'
import { usePortalStore } from '#src/hooks/usePortalStore.ts'

const WRITE_INTERACTIONS = ['create', 'update', 'delete']

function allowsWrite(r: AccessPolicyResource): boolean {
  if (r.readonly) {
    return false
  }
  // TODO: implement resource level permissions when we need it
  if (!r.interaction) {
    return true
  }
  return r.interaction.some((i) => WRITE_INTERACTIONS.includes(i))
}

export function isAccessPolicyReadOnly(accessPolicy?: AccessPolicy): boolean {
  if (!accessPolicy?.resource?.length) {
    return false
  }
  return !accessPolicy.resource.some(allowsWrite)
}

export function useIsReadOnly(): boolean {
  const medplum = useMedplum()
  const groupOverride = usePortalStore((state) => state.groupOverride)

  const readOnly = useContext(ConfigContext)?.readOnly

  if (readOnly || groupOverride === Group.AUDITOR) {
    return true
  }

  return isAccessPolicyReadOnly(medplum.getAccessPolicy())
}
